import {
  MemberStageDto,
  SegmentDto,
  SurveyAdmin,
  SurveyV2,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

const SURVEY_ADMIN_PATH = '/surveys/admin';

export const surveyAdminRequests = {
  archiveSurvey: EndpointDefinition.patch<
    SurveyV2.SurveyDto,
    null,
    { surveyId: number }
  >({
    name: 'archiveSurvey',
    route: `${SURVEY_ADMIN_PATH}/archive/:surveyId`,
  }),
  getAllStagesAndSegments: EndpointDefinition.get<
    { stages: MemberStageDto[]; segments: SegmentDto[] },
    null
  >({
    name: 'getStagesAndSegments',
    route: `${SURVEY_ADMIN_PATH}/stages_segments`,
  }),

  updateAssignmentConfiguration: EndpointDefinition.patch<
    SurveyV2.SurveyDto,
    SurveyV2.UpdateAssignmentConfigRequest,
    { id: number }
  >({
    name: 'updateAssignmentConfiguration',
    route: `${SURVEY_ADMIN_PATH}/assignment/:id`,
  }),

  getSurveyRecords: EndpointDefinition.get<
    SurveyAdmin.SurveyCreatorRecordDto[],
    null
  >({
    name: 'getSurveyRecords',
    route: `${SURVEY_ADMIN_PATH}/survey-record`,
  }),

  getSurveyRecordById: EndpointDefinition.get<
    SurveyAdmin.SurveyCreatorRecordDto,
    { id: number }
  >({
    name: 'getSurveyRecordById',
    route: `${SURVEY_ADMIN_PATH}/survey-record/:id`,
  }),

  getLearnMoreRecords: EndpointDefinition.get<
    SurveyAdmin.LearnMoreCreatorRecordDto[],
    null
  >({
    name: 'getLearnMoreRecords',
    route: `${SURVEY_ADMIN_PATH}/learn-more`,
  }),

  getLearnMoreRecordById: EndpointDefinition.get<
    SurveyAdmin.LearnMoreCreatorRecordDto,
    { id: number }
  >({
    name: 'getLearnMoreRecordById',
    route: `${SURVEY_ADMIN_PATH}/learn-more/:id`,
  }),

  createSurveyCreatorRecord: EndpointDefinition.post<
    SurveyAdmin.SurveyCreatorRecordDto,
    SurveyAdmin.SurveyCreatorRecordRequestDto,
    null
  >({
    name: 'createSurveyCreatorRecord',
    route: `${SURVEY_ADMIN_PATH}/survey-record`,
  }),

  updateSurveyCreatorRecord: EndpointDefinition.patch<
    SurveyAdmin.SurveyCreatorRecordDto,
    SurveyAdmin.SurveyCreatorRecordRequestDto,
    { id: number }
  >({
    name: 'updateSurveyCreatorRecord',
    route: `${SURVEY_ADMIN_PATH}/survey-record/:id`,
  }),

  publishSurveyCreatorRecord: EndpointDefinition.post<
    SurveyAdmin.SurveyCreatorRecordDto,
    SurveyAdmin.SurveyCreatorRecordRequestDto,
    { id: number }
  >({
    name: 'publishSurveyCreatorRecord',
    route: `${SURVEY_ADMIN_PATH}/survey-record/:id/publish`,
  }),

  deleteSurveyCreatorRecord: EndpointDefinition.delete<
    SurveyAdmin.SurveyCreatorRecordDto,
    { id: number }
  >({
    name: 'deleteSurveyCreatorRecord',
    route: `${SURVEY_ADMIN_PATH}/survey-record/:id`,
  }),

  createLearnMoreCreatorRecord: EndpointDefinition.post<
    SurveyAdmin.LearnMoreCreatorRecordDto,
    SurveyAdmin.LearnMoreCreatorRecordRequestDto,
    null
  >({
    name: 'createLearnMoreCreatorRecord',
    route: `${SURVEY_ADMIN_PATH}/learn-more`,
  }),

  updateLearnMoreCreatorRecord: EndpointDefinition.patch<
    SurveyAdmin.LearnMoreCreatorRecordDto,
    SurveyAdmin.LearnMoreCreatorRecordRequestDto,
    { id: number }
  >({
    name: 'updateLearnMoreCreatorRecord',
    route: `${SURVEY_ADMIN_PATH}/learn-more/:id`,
  }),

  deleteLearnMoreCreatorRecord: EndpointDefinition.delete<
    SurveyAdmin.LearnMoreCreatorRecordDto,
    { id: number }
  >({
    name: 'deleteLearnMoreCreatorRecord',
    route: `${SURVEY_ADMIN_PATH}/learn-more/:id`,
  }),
};
